module.exports = __webpack_public_path__ + "img/lg_ring_0_0_1_1.df4dc7aa.png";